import { inject } from '@angular/core'
import { CanMatchFn, Router } from '@angular/router'
import { FeatureFlagService } from 'src/app/@core/services/feature-flag/feature-flag.service'

// Com a flag desligada, a web pública de torneios não existe: quem chegar em
// /torneios ou /minhas-inscricoes volta para a página inicial.
export const publicTournamentsGuard: CanMatchFn = () => {
  if (inject(FeatureFlagService).isEnabled('publicTournaments')) return true
  return inject(Router).createUrlTree(['/'])
}
